.segmentsButtonWrapper {
  display: flex;
}

.segmentsButton {
  display: flex;
  flex-direction: row;
  gap: 4px;
}
